<template>
    <span>{{count}} {{ kind | pluralize(count) }} <slot></slot></span>
</template>

<script>
    export default {
        name: 'Statistic',
        props: {
            count: Number,
            kind: String
        }
    }
</script>